import React, { useState } from 'react';
import axios from 'axios';
function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobile: '',
        subject: '',
        message: '',
    });
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('https://praneeshinfotech.com/praneeshinfotech_api/mail.php', {
                name: formData.name,
                email: formData.email,
                mobile: formData.mobile,
                subject: formData.subject,
                message: formData.message
            });
            if (response?.data?.success) {
                alert('Message sent successfully!, We aim to respond to all messages within 2 working days');
                setFormData({
                    name: '',
                    email: '',
                    mobile: '',
                    subject: '',
                    message: '',
                });
            }
        } catch (error) {
            console.error('Error:', error);
            alert('There was an error sending your message.');
        } finally {

        }
    };
    return (
        <div>
            <div className="page-title-area">
                <div className="d-table">
                    <div className="d-table-cell">
                        <div className="container">
                            <div className="page-title-content">
                                <h2>Contact</h2>
                                <ul>
                                    <li><a href="/">Home</a>
                                    </li>
                                    <li>Contact</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="contact-section section-padding">
                <div className="container">
                    <div className="section-title">
                        <h2>Get In Touch</h2>
                    </div>
                    <div className="row align-items-center">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="contact-form">
                                <p className="form-message"></p>
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <input
                                                    name="name"
                                                    placeholder="Name"
                                                    type="text"
                                                    className="form-control"
                                                    autoComplete="off"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <input
                                                    name="email"
                                                    placeholder="Email"
                                                    type="email"
                                                    className="form-control"
                                                    autoComplete="off"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <input
                                                    name="mobile"
                                                    placeholder="Mobile"
                                                    type="text"
                                                    autoComplete="off"
                                                    value={formData.mobile}
                                                    className="form-control"
                                                    onChange={handleChange}
                                                    required />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <input
                                                    name="subject"
                                                    type="text"
                                                    placeholder="Subject"
                                                    className="form-control"
                                                    value={formData.subject}
                                                    autoComplete="off"
                                                    onChange={handleChange}
                                                    required />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                            <div className="form-group">
                                                <textarea
                                                    name="message"
                                                    placeholder="Type your message here..."
                                                    className="form-control" id="message" cols="30" rows="6"
                                                    value={formData.message}
                                                    autoComplete="off"
                                                    onChange={handleChange}
                                                    required></textarea>
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                            <button type="submit" className="default-btn submit-btn">Send Message <span></span></button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="contact-info-wrapper bg-grey">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="section-title">
                                <h2>Contact Info</h2>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="contact-info-content">
                                <h5>Call Us</h5>
                                <a href="tel:+919487924282">+91 9487924282,</a>
                                <a href="tel:+919715670024">+91 9715670024</a>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="contact-info-content">
                                <h5>Email Us</h5>
                                <a href="mailto:praneeshinfotech@gmail.com">praneeshinfotech@gmail.com</a><br />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="contact-info-content">
                                <h5>Address</h5>
                                <a href="/">27-B/5, Ayyampalayam Pudur, Ayyampalayam (Post), Kavindapadi - Erode - 638455</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Contact
